import React from 'react';
import { Link } from 'react-router-dom';

import { Phone, MessageSquare } from 'lucide-react';
import './ModernCTA.scss';

const ModernCTA = () => {
    return (
        <section className="jk-cta">
            <div className="jk-cta__bg">
                <div className="jk-cta__bg-pattern"></div>
                <div className="jk-cta__bg-glow jk-cta__bg-glow--1"></div>
                <div className="jk-cta__bg-glow jk-cta__bg-glow--2"></div>
            </div>

            <div className="jk-cta__container">
                <div className="jk-cta__content">
                    <h2 className="jk-cta__title">
                        Ready to Transform Your
                        <span className="jk-cta__title-highlight"> Technology?</span>
                    </h2>
                    <p className="jk-cta__description">
                        Partner with Jaak Tech for comprehensive IT solutions tailored to your needs.
                        Our experts are ready to help you succeed.
                    </p>

                    <div className="jk-cta__actions">
                        <Link to="/contact" className="jk-btn jk-btn--white jk-btn--lg">
                            <MessageSquare size={20} />
                            Get In Touch
                        </Link>
                        <a href="tel:+11234567890" className="jk-btn jk-btn--outline-light jk-btn--lg">
                            <Phone size={20} />
                            Call Us Now
                        </a>
                    </div>

                    <div className="jk-cta__features">
                        <div className="jk-cta__feature">
                            <span className="jk-cta__feature-check">✓</span>
                            <span>Free Consultation</span>
                        </div>
                        <div className="jk-cta__feature">
                            <span className="jk-cta__feature-check">✓</span>
                            <span>Expert Support</span>
                        </div>
                        <div className="jk-cta__feature">
                            <span className="jk-cta__feature-check">✓</span>
                            <span>Quick Response</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ModernCTA;
